var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M4.16 14.4a.64.64 0 0 1-.634-.73l.594-4.163-2.333-2.334a.64.64 0 0 1 .347-1.084l3.519-.587 1.774-3.548a.64.64 0 0 1 1.148.006l1.698 3.49 3.598.64a.64.64 0 0 1 .34 1.083l-2.333 2.334.595 4.162a.64.64 0 0 1-.923.662l-3.506-1.775-3.601 1.778a.6.6 0 0 1-.284.066",
  clipRule: "evenodd"
})));
export { SvgStar as ReactComponent };
export default __webpack_public_path__ + "static/media/star.e3483d73.svg";